<template>
  <div>
    <!-- Edit -->
    <a-modal v-model="visible" title="Edit board Details" onOk="handleOk">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleEdit">Update Section</a-button>
      </template>
      <a-spin :spinning="spinning">
        <a-form class="mb-4" :form="form">
          <a-form-item label="Name">
            <a-input
              placeholder="Name"
              v-decorator="['name', {rules: [{ required: true, message: 'Please input a section name!' }, {max: 20, message: 'Section name must not exceed 20 characters!'}]}]"
            />
          </a-form-item>
          <a-form-item label="Description">
            <a-textarea placeholder="Description" :autosize="{minRows: 2}" v-decorator="['description', {rules: [{ max: 100, message: 'Description must not exceed 100 characters!' }]}]" />
          </a-form-item>
        </a-form>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import pick from 'lodash/pick'

export default {
  name: 'EditSection',
  data: function() {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      spinning: false,
      sectionId: null,
    }
  },
  mounted: function () {
    this.$eventBus.$on('openSectionEditModal', this.showModal)
  },
  methods: {
    showModal: function(sectionId) {
      this.sectionId = sectionId
      this.visible = true
      this.loading = true
      this.spinning = true
      this.$http.get('/api/section/' + sectionId).then(({ data }) => {
        const editData = pick({ ...data.data }, ['name', 'description'])
        this.form.setFieldsValue(editData)
        this.spinning = false
        this.loading = false
      })
    },
    handleEdit: function (e) {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$confirm({
            title: `Are you sure you want to update ${values.name}?`,
            content: `Click on the OK button to update the details!`,
            onOk: () => {
              this.$http
                .patch('/api/section/' + this.sectionId, {
                  name: values.name,
                  description: values.description,
                })
                .then(() => {
                  this.$emit('edited')
                  this.loading = false
                  this.visible = false
                  this.$notification['success']({
                    message: 'Successfully edited',
                    description: 'Section details edited successfully!',
                  })
                })
                .catch(error => {
                  this.loading = false
                  this.$neoNotify.error(error)
                })
            },
            onCancel: () => {
              this.loading = false
            },
          })
        }
      })
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
  },
}
</script>
